module.exports = __webpack_public_path__ + "static/resource-toggl-plan-blueprint-33bdf150748431bf3a8cd64c287cba29.png";